export default __webpack_public_path__ + "static/char-v-10-b318f884659081d8450cf93f094262fe.webp";